import {EmpresasActions, EmpresasActionTypes} from './empresas.actions';
import {empresasAdapter, EmpresasState, initialState} from './empresas.state';

export function empresasReducer(
  state = initialState,
  action: EmpresasActions
): EmpresasState {
  switch (action.type) {
    // load
    case EmpresasActionTypes.EMPRESAS_LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case EmpresasActionTypes.EMPRESAS_LOAD_SUCCESS: {
      return empresasAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case EmpresasActionTypes.EMPRESAS_LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }

    case EmpresasActionTypes.EMPRESAS_REGISTRER_REDIRECT: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }

    case EmpresasActionTypes.EMPRESAS_REGISTRER_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }

    // default
    default: {
      return state;
    }
  }
}
